import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { getGradient } from '../../utils';
import { useStickyComponent } from '../../hooks';

import type { TStickyHeader } from './models';

export const StickyHeader: FC<React.PropsWithChildren<TStickyHeader>> = ({
    children,
    dataTestId,
    styles,
    theme,
}) => {
    const { isHidden, isSticky, processScroll: process } = useStickyComponent();

    return (
        <div
            className={cn(styles.stickyWrapper, {
                [styles.sticky]: isSticky,
                [styles.hidden]: isHidden,
            })}
            data-test-id={dataTestId}
        >
            <div
                className={cn(styles.stickyLayout)}
                style={{
                    background: getGradient({
                        process,
                        theme,
                    }),
                }}
            >
                <div className={cn(styles.stickyLayoutContent)}>{children}</div>
            </div>
        </div>
    );
};
